module.exports={
	"Scope": "ArtifactType-List",
	"CoreEntity": "ArtifactType",
	"TitleTemplate": "Artifact Types",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "ArtifactTypeListName",
			"PictDashboard": {}
		}
	}
}
